import { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../../services/api';

const INPUT_STYLE = {
  padding: '13px 14px',
  borderRadius: 12,
  border: '1.5px solid #e8e4de',
  fontSize: '16px',
  fontFamily: "'Sora', sans-serif",
  background: '#fff',
  outline: 'none',
  width: '100%',
  boxSizing: 'border-box',
  WebkitAppearance: 'none',
};

export default function RedefinirSenha() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [params] = useSearchParams();
  const empresaId = params.get('empresa_id');

  const [status, setStatus] = useState('validando'); // 'validando' | 'valido' | 'invalido' | 'sucesso'
  const [form, setForm] = useState({ nova_senha: '', confirmar: '' });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function validar() {
      try {
        await api.post('/auth/validar-token-reset', { token });
        setStatus('valido');
      } catch {
        setStatus('invalido');
      }
    }
    validar();
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.nova_senha || !form.confirmar) {
      toast.error('Preencha os dois campos');
      return;
    }
    if (form.nova_senha.length < 6) {
      toast.error('A senha deve ter no mínimo 6 caracteres');
      return;
    }
    if (form.nova_senha !== form.confirmar) {
      toast.error('As senhas não coincidem');
      return;
    }

    setLoading(true);
    try {
      await api.post('/auth/confirmar-reset', { token, nova_senha: form.nova_senha });
      setStatus('sucesso');
    } catch (err) {
      toast.error(err.response?.data?.erro || 'Erro ao redefinir senha');
    } finally {
      setLoading(false);
    }
  };

  const loginUrl = empresaId
    ? `/cliente/login?empresa_id=${empresaId}`
    : '/cliente/login';

  return (
    <div style={{ minHeight: '100dvh', background: '#F8F7F4', fontFamily: "'Sora', sans-serif" }}>
      <header style={{
        background: '#1A1A2E',
        padding: '16px 20px',
        paddingTop: 'max(16px, env(safe-area-inset-top))',
      }}>
        <div style={{ maxWidth: 480, margin: '0 auto' }}>
          <h1 style={{ color: '#fff', fontSize: '1rem', fontWeight: 800, margin: 0 }}>
            Nova senha
          </h1>
        </div>
      </header>

      <div style={{ maxWidth: 480, margin: '0 auto', padding: '24px 16px' }}>
        <div style={{ background: '#fff', borderRadius: 20, padding: '32px 24px',
          boxShadow: '0 4px 24px rgba(0,0,0,.07)' }}>

          {status === 'validando' && (
            <div style={{ textAlign: 'center', padding: '20px 0' }}>
              <div style={{
                width: 36, height: 36, border: '3px solid #eee', borderTopColor: '#FF6B35',
                borderRadius: '50%', animation: 'spin .7s linear infinite', margin: '0 auto 16px',
              }} />
              <p style={{ color: '#888', fontSize: '.9rem' }}>Verificando link...</p>
            </div>
          )}

          {status === 'invalido' && (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: 16 }}>⏰</div>
              <h2 style={{ margin: '0 0 12px', color: '#1A1A2E', fontSize: '1.1rem', fontWeight: 800 }}>
                Link expirado
              </h2>
              <p style={{ margin: '0 0 28px', color: '#666', fontSize: '.9rem', lineHeight: 1.6 }}>
                Este link de redefinição é inválido ou já expirou. Solicite um novo link.
              </p>
              <button onClick={() => navigate(loginUrl)} style={{
                background: '#FF6B35', color: '#fff', border: 'none', borderRadius: 14,
                padding: '13px 28px', fontWeight: 800, fontSize: '.95rem',
                cursor: 'pointer', fontFamily: 'inherit',
                boxShadow: '0 4px 16px rgba(255,107,53,.3)',
              }}>
                Voltar ao login
              </button>
            </div>
          )}

          {status === 'sucesso' && (
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '3rem', marginBottom: 16 }}>✅</div>
              <h2 style={{ margin: '0 0 12px', color: '#1A1A2E', fontSize: '1.1rem', fontWeight: 800 }}>
                Senha redefinida!
              </h2>
              <p style={{ margin: '0 0 28px', color: '#666', fontSize: '.9rem', lineHeight: 1.6 }}>
                Sua nova senha foi salva. Agora você pode fazer login.
              </p>
              <button onClick={() => navigate(loginUrl)} style={{
                background: '#FF6B35', color: '#fff', border: 'none', borderRadius: 14,
                padding: '13px 28px', fontWeight: 800, fontSize: '.95rem',
                cursor: 'pointer', fontFamily: 'inherit',
                boxShadow: '0 4px 16px rgba(255,107,53,.3)',
              }}>
                Fazer login
              </button>
            </div>
          )}

          {status === 'valido' && (
            <>
              <h2 style={{ margin: '0 0 8px', color: '#1A1A2E', fontSize: '1.1rem', fontWeight: 800 }}>
                Crie uma nova senha
              </h2>
              <p style={{ margin: '0 0 24px', color: '#888', fontSize: '.875rem', lineHeight: 1.6 }}>
                Escolha uma senha com no mínimo 6 caracteres.
              </p>
              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <label style={{ fontSize: '.8rem', fontWeight: 700, color: '#444' }}>Nova senha *</label>
                  <input
                    type="password"
                    value={form.nova_senha}
                    onChange={e => setForm(p => ({ ...p, nova_senha: e.target.value }))}
                    placeholder="Mínimo 6 caracteres"
                    style={INPUT_STYLE}
                    onFocus={e => e.target.style.borderColor = '#FF6B35'}
                    onBlur={e => e.target.style.borderColor = '#e8e4de'}
                    autoFocus
                  />
                </div>
                <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  <label style={{ fontSize: '.8rem', fontWeight: 700, color: '#444' }}>Confirmar senha *</label>
                  <input
                    type="password"
                    value={form.confirmar}
                    onChange={e => setForm(p => ({ ...p, confirmar: e.target.value }))}
                    placeholder="Repita a nova senha"
                    style={INPUT_STYLE}
                    onFocus={e => e.target.style.borderColor = '#FF6B35'}
                    onBlur={e => e.target.style.borderColor = '#e8e4de'}
                  />
                </div>
                <button type="submit" disabled={loading} style={{
                  background: loading ? '#ccc' : '#FF6B35',
                  color: '#fff', border: 'none', borderRadius: 14,
                  padding: '14px', fontWeight: 800, fontSize: '1rem',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  fontFamily: 'inherit',
                  boxShadow: loading ? 'none' : '0 4px 16px rgba(255,107,53,.3)',
                }}>
                  {loading ? 'Salvando...' : 'Salvar nova senha'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
